/* Sticky header */
export function initStickyHeader() {
	const header = document.querySelector('.js-omb-header');
	if (!header) return;

	let stickyHeaderOffset;

	updateHeaderHeight();
	stickHeader();
	window.addEventListener('resize', updateHeaderHeight);
	window.addEventListener('scroll', stickHeader);

	function stickHeader() {
		const headerHeight = header.offsetHeight;
		const headerNextSibling = header.nextElementSibling;
		const isStickySibling = Array.from(headerNextSibling?.classList || []).some((className) =>
			['page', 'container-wrap', 'omb-breadcrumbs'].includes(className),
		);
		if (window.scrollY > stickyHeaderOffset) {
			header.classList.add('is-sticky');
			isStickySibling && (headerNextSibling.style.marginTop = `${headerHeight}px`);
			return;
		}
		if (!document.body.classList.contains('disable-scroll')) {
			header.classList.remove('is-sticky');
			isStickySibling && (headerNextSibling.style.marginTop = null);
		}
	}

	function updateHeaderHeight() {
		const mobileHeaderHeight = header.querySelector('.header-mobile')?.offsetHeight;
		const topHeaderHeight = header.querySelector('.omb-header-top')?.offsetHeight;
		const laptopMq = window.matchMedia(`(min-width: ${window.vars.breakpoint.laptop}px)`);

		const headerOffsetPosition = laptopMq.matches ? topHeaderHeight : mobileHeaderHeight;

		stickyHeaderOffset = header.offsetHeight - headerOffsetPosition;
		document.body.style.setProperty('--sticky-header-offset', `${headerOffsetPosition}px`);
		document.body.style.setProperty('--omb-header-height', `${header.offsetHeight}px`);
	}
}
